var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isNotAccepted)?_c('div',{staticClass:"cookie"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('home.cookie'))}}),_c('div',{staticClass:"button",on:{"click":_vm.einv}},[_vm._v("Einverstanden")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }